import { IQuotesState } from '@boldpenguin/sdk';

export const applicationFormVisualizerUrl = (
  baseUri: string,
  applicationFormId: string,
) => `${baseUri}/visualization/application_forms/${applicationFormId}`;

export const quoteRequestSearchUrl = (
  baseUri: string,
  quoteRequest: IQuotesState,
) => {
  const quoteNumber = quoteRequest.quote_number;

  const params: Record<string, string> = {
    'q[application_form_id_eq]': quoteRequest.application_form_id,
    'q[tenant_id_eq]': quoteRequest.carrier.id,
  };

  if (quoteNumber) {
    params['q[quote_number_eq]'] = quoteNumber;
  }

  const queryString = new URLSearchParams(params).toString();
  return `${baseUri}/admin/quote_requests/?${queryString}`;
};
